// These variables are consistent across all sites associated with the Narrative Tracker
var vars = {
  // --------  COLOR VARIABLES  --------------
  // Colors are named with numbers following them, which indicate light/dark range
  //     lower numbers are lighter, higher are darker.
  //     Attempt to use whole numbers, but it's annoying to change variables once
  //        they are implemented, so it's okay to use decimals.
  //     Use '_' instead of a decimal point (. is not allowed in less variables)
  // Attempt to reuse these variables instead of making new ones!!
  exoveraGreen: "#88c400",
  exoveraGreen_hover: "#76ab00",
  exoveraNavy: "#253b77",
  exoveraDarkNavy: "#0e0e4b",
  exoveraDarkGreen: "#519501",
  exoveraDarkGreen_hover: "#458000",
  exoveraBlue: "#2462b8",
  exoveraBlue_hover: "#1e57a8",

  // Light colors simiar to the logo
  exoveraBlueLight: "#7CA9F3",
  exoveraGreenLight: "#C3E38B",

  sosi_purple_1: "#6f297b",
  sosi_purple_2: "#5e1e69",

  accent: "#2462b8", // exovera-blue,
  accentHover: "#1e57a8", // exovera-blue-hover,
  accentLight: "#7dd3e0",
  // @accent-lt:          #96c1c7;
  // @accent-text:        #15e3b5;

  //
  // @text-light-1:       #edf0f5;
  // @text-light-2:       #bcc9e4;
  //
  source: "#92e43f", // #8CC94E; - logo color
  sourceHover: "#76ab00", // exoveraGreen_hover
  audience: "#2084fb", // #2E6FBD; - logo color
  audienceHover: "#1e57a8", // exoveraBlue_hover

  lightGrey_1: "#f9f9f9",
  lightGrey_1_5: "#f3f3f4",
  lightGrey_2: "#ededed",
  lightGrey_3: "#dedede",
  lightGrey_4: "#d2d3d8",

  grey_0_1: "#eff4f7",
  grey_0_2: "#e6edf2",
  grey_0_5: "#e0e8f0",
  grey_1: "#d5deea",
  grey_1_25: "#b8c5d6",
  grey_1_3: "#b6c1d0",
  grey_1_4: "#adbacc",
  grey_1_5: "#a7b7cc",
  grey_1_75: "#99a9bf",
  grey_2: "#7c8faf",
  grey_2_2: "#6F82A2",
  grey_2_5: "#657694",
  grey_2_7: "#4f6180",
  grey_3: "#465777",
  grey_3_5: "#354663",
  grey_3_7: "#30405a",
  grey_4: "#2a3851",
  grey_4_3: "#242f4a",
  grey_4_5: "#222d48",
  grey_4_7: "#1f2a46",
  grey_5: "#1c263e",
  grey_5_2: "#192238",

  blueGrey_0_5: "#eff2f4",
  blueGrey_1: "#e6edf2", // @grey-0_2",
  blueGrey_1_5: "#e0e8f0",
  blueGrey_2: "#d9e2ee",
  blueGrey_3: "#cfdce8", // '#cdd6e9',
  blueGrey_4: "#bfd1e2", // '#c0cae5',
  blueGrey_5: "#b3c8e0", // '#b3bfe1',
  blueGrey_6: "#a7c0d8", // '#a6b4dc',
  blueGrey_7: "#99b9d6", // '#99aad8',

  // Midnight to real black
  black_1: "#00023d",
  black_2: "#000123",
  black_3: "#000019",
  black_4: "#000000",

  // @text-1_5: #766e6f;
  // made these cooler. Used by some generic components
  text_1: "#7c8faf", // @grey-2,
  text_1_5: "#657694", // @grey-2_5,
  text_2: "#465777", // @grey-3,
  text_2_5: "#354663", // @grey-3_5,
  text_3: "#2a3851", // @grey-4,
  text_4: "#111111",

  charcoal_0_5: "#2D415F",
  charcoal_0_8: "#293350",
  charcoal_0_9: "#242C46",
  charcoal_1: "#1f273d",
  charcoal_1_2: "#192035",
  charcoal_2: "#131C32",
  charcoal_2_5: "#0f1628",
  charcoal_3: "#0d1323",

  offWhite_1: "#fafafa",

  darkGrey_1: "#203056",
  darkGrey_2: "#15223d",
  darkGrey_3: "#131c32", // charcoal_2
  darkGrey_4: "#090e19",
  darkGrey_5: "#010205", // as close to black as you can get without your eyes getting wet

  sky_0_5: "#c0d9f9",
  sky_1: "#accaf2", // a very grey blue
  sky_2: "#85a7d5",

  // Blue/red color scheme. These work together in a chart, but not necessarily on all backgrounds
  left_1: "#4e76e7",
  left_2: "#0d5fff",
  left_3: "#caf5ff", // Dark UI only
  left_4: "#8eb4ff",
  left_5: "#0000ff", // Pure blue - avoid if possible
  left_6: "#0000af", // Light UI only
  left_7: "#1028ff", // Light UI pure blue version

  right_1: "#af2345",
  right_2: "#ff5f5f", // fleshy, dark UI only
  right_3: "#ff0000", // pure red
  right_4: "#d30003",
  right_5: "#a80004",
  right_6: "#7f0000", // Light UI only
  right_7: "#ea1d4f", // dark pink
  right_8: "#e8272a", // Light red - looks good  on white, but doesn't necessarily work next to other reds

  left_shade_light: "#ABC7FD",
  left_shade_dark: "#334678",
  right_shade_light: "#FEA0A2",
  right_shade_dark: "#502a51",

  grass_1: "#7FBC0D",
  grass_2: "#61b202",

  seaGreen_1: "#23C7B4",
  seaGreen_2: "#1ab2a0",
  seaGreen_3: "#009e7d",

  chartruese_1: "#B2CE09",

  pistachio_10: "#d8f7a3",
  pistachio_20: "#d0f099",
  pistachio_30: "#bbe079",
  pistachio_40: "#b6db76",

  blackberry_10: "#131433",
  blackberry_20: "#0f102b",
  blackberry_30: "#0a0a21",
  blackberry_40: "#07071c",

  viridian_10: "#063742",
  viridian_20: "#042e38",
  viridian_30: "#002831",
  viridian_40: "#011f26",
  viridian_50: "#001114",

  lime_1: "#00CC35",
  lime_2: "#00b22f",
  lime_3: "#009928",
  lime_4: "#007005",

  cornflower_1: "#3E9BF7",
  cornflower_2: "#328be5",

  royalBlue_1: "#2C44F4",
  royalBlue_2: "#2232e0",

  slate_1: "#8b96a8", // Not as blue as the greys above

  magenta_1: "#c30286",

  plum_1: "#92278f",

  purple_1: "#8243c6",
  purple_2: "#542792",

  lilac_1: "#a38dff",

  blue_0_5: "#4aa7f9",
  blue_1: "#367cb8",
  blue_1_5: "#22739D",
  blue_2: "#444297",

  seal_2: "#59688E",
  seal_3: "#45557d",
  seal_4: "#343F5F",

  cerulean_1: "#1cc2ff", // different from other Exovera app cerulean-1 colors
  cerulean_1_5: "#13b7f2",
  cerulean_2: "#0fa8e0",
  cerulean_3: "#0791c4",

  seafoam_1: "#0bbfd6",

  olive_1: "#429d69", // top liberal

  mint_1: "#00b792",

  moss_70: "#3c5a17",

  chartreuse_1: "#c3ca00",
  chartreuse_2: "#86c419",

  yellow_1: "#fddf6b",
  yellow_2: "#f2ce41",
  yellow_3: "#f7c20a",

  persimmon_1: "#f27210", // Not used in narrative color scheme
  persimmon_2: "#d84b04",

  tangelo_1: "#ef8700", // Error message color
  tangelo_2: "#ed6500",

  red_1: "#7f0000",

  skyBlue_1: "#c1eeff",
  skyBlue_2: "#94e2ff",

  // Social Colors:
  facebook: "#3b5998",
  linkedin: "#007bb6",
  pinterest: "#d73532",
  qq: "#0096d3",
  reddit: "#ff4500",
  tumblr: "#314358",
  twitter: "#50abf1",
  vine: "#00b386",
  wechat: "#51c332",
  whatsapp: "#00a859",
  youtube: "#cd201f",

  // ------ Fonts -------
  // Fonts should be included via googleapis.com link in the header
  mainfont: "font-family: 'Montserrat', Verdana, Geneva, sans-serif; font-weight: 300",
  mainfontBold: "font-family: 'Montserrat', Verdana, Geneva, sans-serif; font-weight: 400",
  mainfontBlack: "font-family: 'Montserrat', Verdana, Geneva, sans-serif; font-weight: 500",
  mainfontLight: "font-family: 'Montserrat', Verdana, Geneva, sans-serif; font-weight: 200",
  numberfont: "font-family: 'Montserrat', Verdana, Geneva, sans-serif; font-weight: 400",
  numberfontBold: "font-family: 'Montserrat', Verdana, Geneva, sans-serif; font-weight: 500"
  // mainfont:
  //   "font-family: 'Raleway', Verdana, Geneva, sans-serif; font-weight: 400",
  // mainfontBold:
  //   "font-family: 'Raleway', Verdana, Geneva, sans-serif; font-weight: 500",
  // mainfontLight:
  //   "font-family: 'Raleway', Verdana, Geneva, sans-serif; font-weight: 200",
  // numberfont:
  //   "font-family: 'Open Sans', Verdana, Geneva, sans-serif; font-weight: 400",
  // numberfontBold:
  //   "font-family: 'Open Sans', Verdana, Geneva, sans-serif; font-weight: 600"
};

// Component Colors
var widgetBodyColorLight = "#fff";
var widgetBodyColorDark = vars.charcoal_1;
var widgetBorderColorLight = vars.blueGrey_5;
var widgetBorderColorDark = vars.charcoal_2;
var widgetHeaderColorLight = "#fff";
var widgetHeaderColorDark = vars.darkGrey_2;
var widgetBoxShadowDark = "0 1px 2px 0px rgba(0,0,0,0.3)";
var widgetBoxShadowLight = "0 1px 2px 0px rgba(0,0,0,0.3)";

// -------- reusuable styles -------
var headerFont = function headerFont() {
  return "\n\t\tfont-size: 18px;\n\t\t" + vars.mainfontBold + ";\n\t\tcolor: #fff;\n\t\ttext-align: center;\n\t\ttext-transform: lowercase;\n\t\tfont-variant: small-caps;\n\t\tletter-spacing: 0.0625em;\n\t";
};

// default color is cerulean_1
// NOTE: This isn't compatible with elements that already have border style
var focusStyle = function focusStyle() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#1cc2ff";
  var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

  return "\n\t\tborder: 1px solid transparent;\n\t\t&:focus {\n\t\t\tborder: 1px solid " + color + ";\n\t\t\toutline: none;\n\t\t\tborder-radius: " + radius + "px;\n\t\t\tbox-shadow: 0 0 22px -5px " + color + ";\n\t\t}\n\t";
};

// -------------  Buttons  --------------
// textColor is optional (uses white instead)
var solidButton = function solidButton(color, hoverColor, textColor, hoverTextColor, elevate) {
  return "\n\t\tpadding: 7px 6px 7px;\n\t\tborder-radius: 2px;\n\t\tcursor: pointer;\n\t\tbackground-color: " + color + ";\n\t\tborder: solid 1px " + color + ";\n\t\ttext-align: center;\n\t\tcursor: pointer;\n    user-select: none;\n\t\ttransition: opacity 200ms ease-out 50ms,\n\t\t\t\t\t\t\t\tbackground-color 200ms ease-out 50ms,\n\t\t\t\t\t\t\t\tborder-color 200ms ease-out 50ms,\n\t\t\t\t\t\t\t\tcolor 200ms ease-out 50ms;\n\t\t&:hover, &:active {\n\t\t\tbackground-color: " + hoverColor + ";\n\t\t\tborder-color: " + hoverColor + ";\n      color: " + (hoverTextColor || textColor || '#fff') + ";\n\t\t}\n\t\t&:active:hover, &:active:focus {\n\t\t\tbackground-color: " + (elevate ? hoverColor : color) + ";\n  \t\tbox-shadow: " + (elevate ? '0 0px 3px 0px rgba(0, 0, 0, 0.3)' : 'none') + ";\n      transition: none;\n\t\t}\n\t\tfont-size: 15px;\n\t\tcolor: " + (textColor || '#fff') + ";\n\t\ttext-transform: lowercase;\n\t\tfont-variant: small-caps;\n\t\tletter-spacing: 0.0625em;\n\n\t\tspan, p {\n\t\t\tfont-size: 18px;\n\t\t\tcolor: " + (textColor || '#fff') + ";\n\t\t\ttext-transform: lowercase;\n\t\t\tfont-variant: small-caps;\n\t\t\tletter-spacing: 0.0625em;\n      margin-bottom: 3px;\n\t\t}\n\t";
};

// Outline Button
// 		textColor and hoverTextColor optional (uses color & hoverColor instead)
var outlineButton = function outlineButton(color, hoverColor, textColor, hoverTextColor, bgColor, hoverBgColor, activeOpacity) {
  return "\n\t\tposition: relative;\n\t\tpadding: 7px 6px 7px;\n\t\tborder-radius: 2px;\n\t\tcursor: pointer;\n\t\tborder: solid 1px " + color + ";\n\t\tbackground-color: " + (bgColor || 'transparent') + ";\n\t\ttext-align: center;\n\t\tcursor: pointer;\n    user-select: none;\n\t\tfont-size: 15px;\n\t\tcolor: " + (textColor || color) + ";\n\t\ttext-transform: lowercase;\n\t\tfont-variant: small-caps;\n\t\tletter-spacing: 0.0625em;\n\t\ttransition: opacity 200ms ease-out 50ms,\n\t\t\t\t\t\t\t\tbackground-color 200ms ease-out 50ms,\n\t\t\t\t\t\t\t\tborder-color 200ms ease-out 50ms,\n\t\t\t\t\t\t\t\tcolor 2000ms ease-out 50ms;\n\t\t\n    &:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\ttop: 0;\n\t\t\tbottom: 0;\n\t\t\tz-index: 0;\n      background-color: " + (hoverBgColor || '#000') + ";\n\t\t\topacity: 0;\n\t\t\ttransition: opacity 0ms, background-color 0ms ease-out 50ms;\n\t\t}\n\n\t\t&:hover, &:active {\n\t\t\tcolor: " + (hoverTextColor || hoverColor) + ";\n      background-color: " + (hoverBgColor || bgColor || 'transparent') + ";\n\t\t\tborder-color: " + (hoverTextColor || hoverColor) + ";\n\t\t\t&:after {\n\t\t\t\topacity: " + (activeOpacity || 0.08) + ";\n\t\t\t}\n      span, p {\n        color: " + (hoverTextColor || hoverColor) + ";\n      }\n      svg {\n        path {\n          fill: " + (hoverTextColor || hoverColor) + "\n        }\n      }\n\t\t}\n\n\t\t&:active:hover, &:active:focus {\n\t\t\tcolor: " + (textColor || color) + ";\n\t\t\tborder-color: " + (textColor || color) + ";\n\t\t\t&:after {\n        background-color: " + '#000' + ";\n\t\t\t}\n      span, p {\n        color: " + (textColor || color) + ";\n      }\n      svg {\n        path {\n          fill: " + (textColor || color) + ";\n        }\n      }\n\t\t}\n\n    &:active, &:active:hover, &:active:focus {\n      transition: none;\n\t\t\t&:after, span, p {\n        transition: none;\n\t\t\t}\n      svg {\n        path {\n          transition: none;\n        }\n      }\n\t\t}\n\n\t\tspan, p {\n\t\t\tfont-size: 18px;\n\t\t\tcolor: " + (textColor || color) + ";\n\t\t\ttext-transform: lowercase;\n\t\t\tfont-variant: small-caps;\n\t\t\tletter-spacing: 0.0625em;\n      margin-bottom: 3px;\n      transition: color 200ms ease-out 50ms;\n\t\t}\n\n    svg {\n      path {\n        transition: fill 200ms ease-out 50ms;\n      }\n    }\n\t";
};

export default vars;
export { widgetBodyColorLight, widgetBodyColorDark, widgetBorderColorLight, widgetBorderColorDark, widgetHeaderColorLight, widgetHeaderColorDark, widgetBoxShadowDark, widgetBoxShadowLight, headerFont, focusStyle, solidButton, outlineButton };
//# sourceMappingURL=index.es.js.map
